import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { catchError, map, Observable, of, switchMap, tap, throwError } from "rxjs";

import { DpopService } from "@core/services/dpop.service";
import { environment } from "@env/environment";
import { LoggerService } from "@core/services/logger.service";

@Injectable()
export class LoggerInterceptor implements HttpInterceptor {

  private readonly dpopService = inject(DpopService);
  private readonly loggerService = inject(LoggerService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const startTime = performance.now(); //record start time
    if(request.url.includes(environment.loggerApiUrl)) {
      return this.addDpopTokenToRequest(request).pipe(switchMap((request) => next.handle(request)));
    }

    //skip logging local logger hash requests
    if(request.url.includes('localhost') && request.url.includes('/logger/hash')) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      //log response
      tap((event: HttpEvent<unknown>) => {
        // Only log if it's an HttpResponse (final response)
        if (event instanceof HttpResponse) {
          const duration = performance.now() - startTime;
          this.loggerService.logRequest(request, duration, event, undefined);
        }
      }),
      //log errors
      catchError((error: HttpErrorResponse) => {
        const duration = performance.now() - startTime;
        this.loggerService.logRequest(request, duration, null, error);
        return throwError(() => error);
      })
    );
  }

  private addDpopTokenToRequest(request: HttpRequest<unknown>): Observable<HttpRequest<unknown>> {
    return this.dpopService.generateDpopToken(request.method, request.url).pipe(map((dpopToken) => {
      return request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.dpopService.dpopToken()}`,
          DPoP: dpopToken,
        }
      });
    }));
  }
}